import React from "react";
import { useRefreshInterval } from "../../contexts/RefreshIntervalContext";

const RefreshIntervalSelector: React.FC = () => {
  const { refreshInterval, setRefreshInterval } = useRefreshInterval();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);

  const options = [5, 10, 15, 30, 60];

  // Close on outside click
  React.useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleSelect = (interval: number) => {
    setRefreshInterval(interval);
    setOpen(false);
  };

  const formatValue = (v: number) => (v < 60 ? `${v}s` : "1m");

  return (
    <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "0.75rem",
          padding: "4px 8px",
          borderRadius: 6,
          color: "#94a3b8",
          display: "flex",
          alignItems: "center",
          gap: 4,
          transition: "background 0.15s",
          whiteSpace: "nowrap",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(148,163,184,0.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
        title="Tự động quét"
        aria-label="Tự động quét"
      >
        <span style={{ fontSize: "0.95rem" }}>🔄</span>
        <span style={{ color: "#e2e8f0", fontWeight: 500 }}>{formatValue(refreshInterval)}</span>
      </button>

      {/* Popover */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            left: 0,
            zIndex: 1000,
            background: "#1e293b",
            borderRadius: 8,
            boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
            border: "1px solid #334155",
            padding: 4,
            minWidth: 100,
          }}
        >
          <div style={{ padding: "4px 10px 6px", color: "#94a3b8", fontSize: "0.7rem" }}>
            Tự động quét:
          </div>
          {options.map((v) => (
            <button
              key={v}
              onClick={() => handleSelect(v)}
              style={{
                display: "flex",
                width: "100%",
                padding: "5px 10px",
                border: "none",
                background: v === refreshInterval ? "rgba(59,130,246,0.15)" : "transparent",
                color: v === refreshInterval ? "#3b82f6" : "#cbd5e1",
                fontSize: "0.8rem",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 6,
                borderRadius: 4,
                transition: "background 0.1s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(148,163,184,0.1)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = v === refreshInterval ? "rgba(59,130,246,0.15)" : "transparent")}
            >
              <span>{formatValue(v)}</span>
              {v === 5 && (
                <span
                  style={{
                    background: "#3b82f6",
                    color: "#fff",
                    fontSize: "0.6rem",
                    fontWeight: 600,
                    padding: "1px 5px",
                    borderRadius: 4,
                    lineHeight: 1.3,
                  }}
                >
                  Nhanh
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RefreshIntervalSelector;
